import { Button, Card, Checkbox, Divider, Modal, Tabs } from "antd";
import { useSelector } from "react-redux";
import { modeSelector } from "../../store/selectors/app.selector";
import { useEffect, useState } from "react";
import { amountFormat } from "../../services/common.service";
import { useLocation } from "react-router";
import { AiOutlineInfoCircle } from "react-icons/ai";
import moment from "moment";
import checkedIcon from "../../assests/images/checked.svg";
import unCheckedIcon from "../../assests/icons/uncheck.png";
import { useTranslation } from "react-i18next";
import AuthorizerComment from "./authoriserComment";

export default function DepositsCard({
  record = {},
  handleCheckBoxChange,
  handleDelete,
  handleApproveOrReject,
}) {
  const { t } = useTranslation();
  const mode = useSelector(modeSelector);
  const [visible, setVisible] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectDetails, setSelectDetails] = useState({});
  const location = useLocation();
  const isPathHistory = location.pathname.includes("/history");
  const [showGridAccount, setShowGridAccount] = useState("GRID");

  useEffect(() => {
    if (window.innerWidth < 900) {
      setShowGridAccount("LIST");
    }
  }, [window.innerWidth]);

  return (
    <>
      {showGridAccount === "GRID" && (
        <tr onClick={() => setVisible(true)}>
          {!isPathHistory && (
            <td
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleCheckBoxChange(!record.isChecked, record);
              }}
            >
              {record.isChecked ? (
                <img
                  src={checkedIcon}
                  alt="checked"
                  width={17}
                  height={17}
                  className="checked"
                />
              ) : (
                <img
                  src={unCheckedIcon}
                  alt="unchecked"
                  width={17}
                  height={17}
                  className="unchecked"
                />
              )}
            </td>
          )}
          <td> {record?.accountNo}</td>
          <td>{amountFormat(record?.amount, record.currency) || "-"}</td>
          <td>{record?.depositType}</td>

          <td>{moment(record?.initDate).format("DD-MM-YYYY") || "-"}</td>
          {isPathHistory && (
            <td>
              {record.authStatus === "A" ? (
                <span className="success-text px-2 py-1">
                  {" "}
                  {t("pages.pending_approval.authorised", {
                    defaultValue: "AUTHORISED",
                  })}
                </span>
              ) : record.authStatus === "I" ? (
                <span className="fail-error px-2 py-1">
                  {t("pages.pending_approval.initiated", {
                    defaultValue: "INITIATED",
                  })}
                </span>
              ) : record.authStatus === "R" ? (
                <span className="fail-error px-2 py-1">
                  {" "}
                  {t("pages.pending_approval.rejected", {
                    defaultValue: "REJECTED",
                  })}
                </span>
              ) : record.authStatus === "P" ? (
                <span className="fail-error px-2 py-1">
                  {t("pages.pending_approval.pending", {
                    defaultValue: "PENDING",
                  })}
                </span>
              ) : (
                <span className="fail-error px-2 py-1">
                  {record.authStatus}
                </span>
              )}
            </td>
          )}
        </tr>
      )}

      {showGridAccount === "LIST" && (
        <div
          onClick={() => setVisible(true)}
          className="account-row-data list-row mb-2"
        >
          <div className="list-row-display-item">
            <div>
              {!isPathHistory && (
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    handleCheckBoxChange(!record.isChecked, record);
                  }}
                >
                  {record.isChecked ? (
                    <img
                      src={checkedIcon}
                      alt="checked"
                      width={17}
                      height={17}
                      className="checked"
                    />
                  ) : (
                    <img
                      src={unCheckedIcon}
                      alt="unchecked"
                      width={17}
                      height={17}
                      className="unchecked"
                    />
                  )}
                </div>
              )}
            </div>
            <div>
              <div className="list-item-heading">
                {record?.accountNo || "-"}
              </div>

              <div className="list-item-heading">{record?.depositType}</div>
            </div>
          </div>
          <div align="right">
            <div className="list-item-heading">
              {amountFormat(record?.amount, record.currency) || "-"}
            </div>
            <div className="list-item-heading mb-1">
              {moment(record?.initDate).format("DD-MM-YYYY") || "-"}
            </div>

            {isPathHistory && (
              <div className="list-item-heading mt-2">
                <div>
                  {record.authStatus === "A" ? (
                    <span className="success-text px-2 py-1">
                      {" "}
                      {t("pages.pending_approval.authorised", {
                        defaultValue: "AUTHORISED",
                      })}
                    </span>
                  ) : record.authStatus === "I" ? (
                    <span className="fail-error px-2 py-1">
                      {t("pages.pending_approval.initiated", {
                        defaultValue: "INITIATED",
                      })}
                    </span>
                  ) : record.authStatus === "R" ? (
                    <span className="fail-error px-2 py-1">
                      {" "}
                      {t("pages.pending_approval.rejected", {
                        defaultValue: "REJECTED",
                      })}
                    </span>
                  ) : record.authStatus === "P" ? (
                    <span className="fail-error px-2 py-1">
                      {t("pages.pending_approval.pending", {
                        defaultValue: "PENDING",
                      })}
                    </span>
                  ) : (
                    <span className="fail-error px-2 py-1">
                      {record.authStatus}
                    </span>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      <Modal
        open={visible}
        footer={null}
        width={650}
        closable={false}
        maskClosable={false}
        mask={true}
        centered
      >
        {record && (
          <div className="confirm-details">
            <h4 className="confirm-title">
              {t("pages.pending_approval.deposit_details", {
                defaultValue: "Deposit Details",
              })}
            </h4>
            <Tabs type="line">
              <Tabs.TabPane
                tab={t("pages.pending_approval.deposit_details", {
                  defaultValue: "Deposit Details",
                })}
                key={"DEPOSITS"}
              >
                <div className="row">
                  <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 mb-3 ">
                    <label>
                      {t("common.account_no_lbl", {
                        defaultValue: "Account Number",
                      })}{" "}
                      :{" "}
                    </label>
                    <span>{record?.accountNo}</span>
                  </div>

                  <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 mb-3 ">
                    <label>
                      {" "}
                      {t("common.amount", { defaultValue: "Amount" })} :{" "}
                    </label>
                    <span>{amountFormat(record?.amount) || "-"}</span>
                  </div>
                  <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 mb-3 ">
                    <label>
                      {t("pages.accounts.deposits.deposit_type", {
                        defaultValue: "Deposit Type",
                      })}
                      :{" "}
                    </label>
                    <span>{record?.depositType || "-"}</span>
                  </div>
                  <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 mb-3 ">
                    <label>
                      {" "}
                      {t("pages.locateUs.branch", {
                        defaultValue: "Branch",
                      })}
                      :{" "}
                    </label>
                    <span>{record?.branch || "-"}</span>
                  </div>
                  <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 mb-3 ">
                    <label>
                      {t("pages.pending_approval.current_level", {
                        defaultValue: "Current Level",
                      })}{" "}
                      :{" "}
                    </label>
                    <span>{record?.currentLevel}</span>
                  </div>

                  <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 mb-3 ">
                    <label>
                      {" "}
                      {t("pages.my_accounts.deposits.nominee_name", {
                        defaultValue: "Nominee name",
                      })}
                      :{" "}
                    </label>
                    <span>{record?.nomineeName}</span>
                  </div>

                  <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 mb-3 ">
                    <label>
                      {" "}
                      {t("pages.my_accounts.deposits.nominee_relation", {
                        defaultValue: "Nominee Relation",
                      })}
                      :{" "}
                    </label>
                    <span>{record?.nomineeRelation || "-"}</span>
                  </div>
                  <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 mb-3 ">
                    <label>
                      {t("pages.accounts.deposits.nominee_address", {
                        defaultValue: "Nominee Address",
                      })}
                      :{" "}
                    </label>
                    <span>{record?.nomineeAddress || "-"}</span>
                  </div>
                  <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 mb-3 ">
                    <label>
                      {t("pages.accounts.deposits.interest_payout", {
                        defaultValue: "Interest payout",
                      })}{" "}
                      :{" "}
                    </label>
                    <span> {amountFormat(record?.interestPayout) || "-"}</span>
                  </div>

                  <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 mb-3 ">
                    <label>
                      {t("pages.pending_approval.initiated_by", {
                        defaultValue: "Initiated By",
                      })}{" "}
                      :{" "}
                    </label>
                    <span>{record?.initBy || "-"}</span>
                  </div>
                  <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 mb-3 ">
                    <label>
                      {t("pages.pending_approval.current_level", {
                        defaultValue: "Current Level",
                      })}{" "}
                      :{" "}
                    </label>
                    <span>{record?.currentLevel}</span>
                  </div>
                  <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 mb-3 ">
                    <label>
                      {t("pages.pending_approval.Initiated_Date", {
                        defaultValue: "Initiated Date",
                      })}{" "}
                      :{" "}
                    </label>
                    <span>
                      {moment(record?.initDate).format("DD.MM.YYYY hh:mm A") ||
                        "-"}
                    </span>
                  </div>
                </div>
              </Tabs.TabPane>

              {["A"].indexOf(mode) > -1 && (
                 <Tabs.TabPane
                 tab={t("pages.pending_approval.authorizer_details", {
                   defaultValue: "Authorization Matrix",
                 })}
                 key={"Authorizer"}
               >
                 <div className="col-12 ">
                   <AuthorizerComment value={record?.events} />
                 </div>
               </Tabs.TabPane>
              )}


             
            </Tabs>
          </div>
        )}
        {/* <Divider /> */}
        <div align="right" className="mt-3">
          {["A"].indexOf(mode) > -1 && !isPathHistory && !record?.isChecked && (
            <>
              <Button
                type="default"
                danger
                onClick={() => {
                  setVisible(false);
                  // setShowRejectModal(true);
                  handleApproveOrReject(record, "R");
                }}
              >
                {t("pages.pending_approval.reject", {
                  defaultValue: "Reject",
                })}
              </Button>
              <Button
                type="default"
                className="btn-primary  mx-3 "
                onClick={() => {
                  setVisible(false);
                  // setShowApproveModal(true);
                  handleApproveOrReject(record, "A");
                }}
              >
                {t("pages.pending_approval.approve", {
                  defaultValue: "Approve",
                })}
              </Button>
            </>
          )}
          {["VR"].indexOf(mode) > -1 &&
            !isPathHistory &&
            !record?.isChecked && (
              <>
                <Button
                  type="default"
                  danger
                  onClick={() => {
                    setVisible(false);
                    // setShowRejectModal(true);
                    handleApproveOrReject(record, "R");
                  }}
                >
                  {t("pages.pending_approval.reject", {
                    defaultValue: "Reject",
                  })}
                </Button>
                <Button
                  type="default"
                  className="btn-primary  mx-3 "
                  onClick={() => {
                    setVisible(false);
                    // setShowApproveModal(true);
                    handleApproveOrReject(record, "A");
                  }}
                >
                  {t("buttons.verify", {
                    defaultValue: "Verify",
                  })}
                </Button>
              </>
            )}
          {/* {mode === "I" && !isPathHistory && !record?.isChecked && (
            <Button
              type="default"
              className="btn-primary  mx-3 "
              onClick={() => {
                setVisible(false);
                setSelectDetails(record);
                setShowModal(true);
              }}
            >
              {t("pages.pending_approval.delete", {
                defaultValue: "Delete",
              })}
            </Button>
          )} */}

          <Button
            type="primary"
            className=" "
            onClick={() => {
              setVisible(false);
            }}
          >
            {t("buttons.close_btn", { defaultValue: "Close" })}
          </Button>
        </div>
      </Modal>
      <Modal
        closable={false}
        maskClosable={false}
        open={showModal}
        footer={null}
        width={450}
        mask={true}
      >
        <div
          style={{ width: 320, margin: "0 auto" }}
          align="center"
          className="mt-2"
        >
          <AiOutlineInfoCircle size={55} className="primary-color" />
          <h6
            className="auth-header-label"
            style={{ textTransform: "initial" }}
          >
            {t("pages.pay_bills.delete_sure_txt", {
              defaultValue: "Are you sure you want to delete?",
            })}
          </h6>
          <div className="mt-4 mb-3" align="center">
            <Button
              style={{ width: 120 }}
              size="large"
              className="secondary-btn"
              onClick={() => setShowModal(false)}
            >
              {t("buttons.no_btn", {
                defaultValue: "No",
              })}
            </Button>
            <Button
              type="primary"
              className="btn-primary"
              style={{ width: 120, marginLeft: 20 }}
              size="large"
              onClick={() => {
                handleDelete(selectDetails);
                setShowModal(false);
              }}
            >
              {t("buttons.yes_btn", {
                defaultValue: "Yes",
              })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
